<template>
  <nav class="cart-bottom-nav" aria-label="Member navigation">
    <b-button
      v-for="tab in tabs"
      :key="tab.name"
      variant="link"
      :class="['nav-item', { 'nav-item--active': activeTab === tab.name }]"
      :aria-label="tab.label"
      :aria-current="activeTab === tab.name ? 'page' : undefined"
      @click="$emit('navigate', tab.name)"
    >
      <i :class="tab.icon"></i>
      <span class="nav-label">{{ tab.label }}</span>
      <b-badge
        v-if="tab.name === 'cart' && cartCount > 0"
        :class="['cart-badge', { 'cart-badge--pulse': badgePulse }]"
        variant="primary"
        pill
      >{{ cartCount }}</b-badge>
    </b-button>
  </nav>
</template>

<script>
export default {
  name: "cartBottomNav",
  props: {
    activeTab: {
      type: String,
      default: "shop",
    },
    cartCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      badgePulse: false,
      tabs: [
        { name: "shop", label: "Shop", icon: "bx bx-store" },
        { name: "cart", label: "Cart", icon: "bx bx-cart" },
        { name: "orders", label: "Orders", icon: "bx bx-list-ul" },
        { name: "profile", label: "Profile", icon: "bx bx-user" },
      ],
    };
  },
  watch: {
    cartCount(newVal, oldVal) {
      if (newVal !== oldVal && newVal > 0) {
        this.badgePulse = true;
        setTimeout(() => {
          this.badgePulse = false;
        }, 300);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/design/tokens/brand";
@import "~@/design/tokens/surfaces";
@import "~@/design/tokens/typography";

.cart-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 56px;
  background: $surface-card;
  border-top: 1px solid $border-default;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 1030;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  color: $text-secondary;
  text-decoration: none;
  min-width: 44px;
  min-height: 44px;
  padding: 4px 8px;

  &:hover,
  &:focus {
    text-decoration: none;
    color: $brand-primary-light;
  }

  &--active {
    color: $brand-primary;

    &:hover,
    &:focus {
      color: $brand-primary;
    }
  }

  i {
    font-size: 20px;
    line-height: 1;
  }
}

.nav-label {
  font-size: $type-small;
  line-height: 1;
  margin-top: 2px;
}

.cart-badge {
  position: absolute;
  top: 0;
  right: -4px;
  font-size: 10px;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  padding: 0 4px;
  transition: transform 0.3s ease;

  &--pulse {
    animation: badge-pulse 0.3s ease;
  }
}

@keyframes badge-pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}
</style>
